import React, { useState } from "react";
import { Button, Row, Col, Modal } from "react-bootstrap";
import ItemTypeSelect from "./ItemTypeSelect";
import Fields from "./Fields";

const CreateDocument = ({ created }) => {
  const [show, set_show] = useState(false);
  const [itemSchema, setItemSchema] = useState(null);
  const [data, set_data] = useState({});

  const clear = () => {
    set_data({});
  };
  const close = () => {
    clear();
    set_show(false);
  };
  const submit = () => {
    created({ ...data, type: itemSchema.csl_slug, itemSchema });
    close();
  };
  return (
    <div>
      <Row>
        <Col
          className="cite__theButton"
          style={{ textAlign: "right", margin: "auto", marginBottom: 10 }}
          md={12}>
          <Button
            className="cite__btn cite__btn-success"
            onClick={() => {
              set_show(true);
            }}
            style={{ margin: "auto" }}>
            <i className="fa fa-plus" aria-hidden="true" />
            <span> افزودن منبع جدید</span>
          </Button>
        </Col>
      </Row>

      <Modal
        size="lg"
        show={show}
        style={{ zIndex: 9999 }}
        className="csl-modal"
        onHide={() => {
          set_show(false);
        }}>
        <Modal.Header closeButton>
          <Modal.Title>سند جدید</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ItemTypeSelect changed={setItemSchema} value={itemSchema} />
          {itemSchema ? (
            <Fields
              schema={itemSchema.schema}
              data={data}
              set_data={set_data}
            />
          ) : null}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="warning" onClick={close}>
            انصراف
          </Button>
          <Button
            onClick={clear}
            variant="default"
            style={{ backgroundColor: "#eee" }}>
            پاک کردن
          </Button>
          <Button variant="primary" onClick={submit}>
            تایید
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CreateDocument;
